import { InjectionToken } from '@angular/core';

export const WS_URL = new InjectionToken<string>('Websocket URL');
export const accountFeatureKey = 'accountFeature';
